import { makeGetStringFunction } from '../strings'
import { defaultStrings, DefaultStrings } from '.'

export enum CountryCode {
  CA = 'CA',
  IE = 'IE',
  GB = 'GB',
  US = 'US',
  AU = 'AU',
  IN = 'IN',
  NZ = 'NZ'
}

export type Country = {
  label: string
  value: CountryCode
}

/**
 * getCountries: Returns an array of countries
 * @param {Partial<DefaultStrings>} strings - UI string overrides
 * @return {Country[]} All available countries, with translated labels
 */
export const getCountries: (strings?: Partial<DefaultStrings>) => Country[] = (
  strings
) => {
  const getString = makeGetStringFunction({
    ...defaultStrings,
    ...strings
  })
  return [
    {
      label: getString('country.name.canada'),
      value: CountryCode.CA
    },
    {
      label: getString('country.name.ireland'),
      value: CountryCode.IE
    },
    {
      label: getString('country.name.united_kingdom'),
      value: CountryCode.GB
    },
    {
      label: getString('country.name.united_states'),
      value: CountryCode.US
    },
    {
      label: getString('country.name.australia'),
      value: CountryCode.AU
    },
    {
      label: getString('country.name.india'),
      value: CountryCode.IN
    },
    {
      label: getString('country.name.new_zealand'),
      value: CountryCode.NZ
    }
  ]
}

/**
 * getCountryCode: Returns a valid country code, defaulting to US
 * @param {string} Input country code string
 * @return {CountryCode} A valid country code
 */
export const getCountryCode: (code?: string) => CountryCode = (code) => {
  return !!CountryCode[code as CountryCode]
    ? CountryCode[code as CountryCode]
    : CountryCode.US
}
